//  @flow

import * as React from 'react';
import PropTypes from 'prop-types';

import Image from '../Image';
import './style.css';

type BlurFallbackProps = {
  className: string,
  src: string,
  fallbackImage: String,
  children: (params: { onImageLoad: () => void, show: boolean }) => React.Node
};

type BlurFallbackState = {
  isLoaded: boolean
};

class ImageBlurFallback extends React.PureComponent<
  BlurFallbackProps,
  BlurFallbackState
> {
  constructor(props: BlurFallbackProps) {
    super(props);
    this.state = {
      isLoaded: false
    };
  }

  onImageLoad = () => {
    const { onLoad } = this.props;
    this.setState({ isLoaded: true });
    if (typeof onLoad === 'function') {
      onLoad();
    }
  };

  render() {
    const { className, onLoad, fallbackImage, src, ...otherProps } = this.props;
    const { isLoaded } = this.state;
    return (
      <div
        className={`${
          isLoaded ? 'visible-fallback' : 'blur-fallback'
        } ${className}`}>
        <Image
          {...otherProps}
          className={className}
          src={src}
          onLoad={this.onImageLoad}
        />
        {!isLoaded && (
          <div
            style={{
              backgroundImage: !fallbackImage
                ? 'linear-gradient(45deg, #ebedee, #bdc3c7)'
                : '',
              animation: !fallbackImage ? 'dim 3s ease infinite' : ''
            }}
            className="Image-fallback">
            {!!fallbackImage && (
              <Image className={className} src={fallbackImage} />
            )}
          </div>
        )}
      </div>
    );
  }
}

ImageBlurFallback.propTypes = {
  className: PropTypes.string.isRequired,
  onLoad: PropTypes.func,
  fallbackImage: PropTypes.string
};

ImageBlurFallback.defaultProps = {
  onLoad: () => {},
  fallbackImage: ''
};

export default ImageBlurFallback;



// WEBPACK FOOTER //
// ./src/Components/ImageBlurFallback/index.js